import type { Control, FieldValues, Path } from "react-hook-form";
import { ClientPortfolioPaymentFrequencyEnum } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { FlatRowFormInput } from "web_myplann/Shared/Components/FlatRow/FlatRowFormInput";
import { FlatRowFormSelect } from "web_myplann/Shared/Components/FlatRow/FlatRowFormSelect";
import { useEnumSelectOptions } from "web_myplann/Shared/Hooks/useEnumSelectOptions";

type PensionContractFieldsProps<
	FormType extends FieldValues,
	TContext,
	TTransformed extends FieldValues | undefined,
> = {
	control: Control<FormType, TContext, TTransformed>;
};

export const PensionContractFields = <
	FormType extends FieldValues,
	TContext,
	TTransformed extends FieldValues | undefined,
>({
	control,
}: PensionContractFieldsProps<FormType, TContext, TTransformed>) => {
	const { t } = useResource();

	const paymentFrequencyOptions = useEnumSelectOptions(
		ClientPortfolioPaymentFrequencyEnum,
		Resources.PortfolioDetail.SharedLabels.Frequency,
		[ClientPortfolioPaymentFrequencyEnum.None],
	);

	return (
		<>
			<FlatRowFormInput
				control={control}
				name={"payment" as Path<FormType>}
				type="float"
				label={t(Resources.Portfolio.AddPension.Fields.payment)}
				placeholder={t(Resources.Portfolio.AddShared.Placeholders.fill)}
				suffix="Kč"
			/>
			<FlatRowFormSelect
				control={control}
				name={"paymentFrequency" as Path<FormType>}
				label={t(Resources.Portfolio.AddPension.Fields.paymentFrequency)}
				options={paymentFrequencyOptions}
			/>
			<FlatRowFormInput
				control={control}
				name={"employerContribution" as Path<FormType>}
				type="float"
				label={t(Resources.Portfolio.AddPension.Fields.employerContribution)}
				placeholder={t(Resources.Portfolio.AddShared.Placeholders.fill)}
				suffix="Kč měsíčně"
			/>
			<FlatRowFormInput
				control={control}
				name={"ageLimit" as Path<FormType>}
				type="number"
				label={t(Resources.Portfolio.AddPension.Fields.ageLimit)}
				placeholder={t(Resources.Portfolio.AddShared.Placeholders.fill)}
				suffix="let"
			/>
			<FlatRowFormInput
				control={control}
				name={"appreciation" as Path<FormType>}
				type="float"
				label={t(Resources.Portfolio.AddPension.Fields.appreciation)}
				placeholder={t(Resources.Portfolio.AddShared.Placeholders.fill)}
				suffix="%"
				isLast
			/>
		</>
	);
};
